// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"MessageWithCTA-Wrapper-1bQaRF","Message":"MessageWithCTA-Message-1xdE5b"};